import React from 'react';
import styles from './Phone.module.scss';
import { FieldType } from 'common/consts/fieldType';
import { isNullOrWhiteSpace } from 'common/helpers/string';
import http from 'app/http';
import qs from 'qs';
import { useHistory } from 'react-router-dom';
import { useAppDispatch } from 'app/hooks';
import { setContent } from 'features/content/reducer';

interface Props {
  Model?: any; // Data from backend
  PageData?: any;
  handleClick: Function;
  setEditPhoneResponseData: Function;
}

const Phone = ({
  Model,
  PageData,
  handleClick,
  setEditPhoneResponseData,
}: Props) => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const getPathnameFromUrl = (url: string) => {
    const link = new URL(url);

    return link.pathname + link.search;
  };

  const onSubmit = async (e: any) => {
    e.preventDefault();
    try {
      const response = await http.get(Model.EditHomePhonePageUrl, {
        headers: {
          'content-type': 'application/x-www-form-urlencoded',
        },
      });
      if (response && response.data) {
        // Get pathname from enpoint url, pathname will be used for redirect and as a key in content state
        const nextPagePath = getPathnameFromUrl(Model.EditHomePhonePageUrl);
        // Add response to store
        dispatch(setContent({ [nextPagePath]: response.data }));
        // Redirect to next step path
        handleClick(true);
        setEditPhoneResponseData(response.data);
      }
    } catch (err) {
      console.error(err);
    }
  };
  return (
    <div className="cards-items">
      <div className="Phonenumber Customerdetails-card">
        <div className="Grid Grid--gutterHz Grid--gutterVz">
          <div className="Grid-cell">
            <div className="Customerdetails-Headerwrapper">
              <label className="Customerdetails-label">
                {PageData.PhoneNumbersLabel}
              </label>
              {(Model?.ContactDetailsConfiguration.homePhone !==
                FieldType.Readonly ||
                Model.ContactDetailsConfiguration.mobilePhone !==
                  FieldType.Readonly) && (
                <div className="Customerdetails-button">
                  {isNullOrWhiteSpace(Model.ContactDetails.PhoneHome) &&
                  isNullOrWhiteSpace(Model.ContactDetails.PhoneMobile) ? (
                    <button
                      onClick={onSubmit}
                      className="Button Button--ghost orange-text js-modal js-contact-edit-modal"
                    >
                      {' '}
                      {PageData.ButtonAddText}
                    </button>
                  ) : (
                    <button
                      onClick={onSubmit}
                      className="Button Button--ghost js-modal js-contact-edit-modal"
                    >
                      {' '}
                      {PageData.ButtonEditText}
                    </button>
                  )}
                </div>
              )}
            </div>
            <div className="List Phonenumber-list data-hj-suppress">
              {Model.PageDataBase.IsPhoneHomeVisible &&
                Model.ContactDetailsConfiguration.homePhone !==
                  FieldType.Unavailable && (
                  <>
                    <dl>
                      <dt> {PageData.PhoneHomeLabel}</dt>
                      {!isNullOrWhiteSpace(Model.ContactDetails.PhoneHome) ? (
                        <dd>{Model.ContactDetails.PhoneHome}</dd>
                      ) : (
                        <>
                          {Model?.ContactDetailsConfiguration.homePhone ===
                          FieldType.Editable ? (
                            <dd className="Phonenumber-add">
                              {PageData.AddNowLabel}
                            </dd>
                          ) : (
                            <dd className="Phonenumber-add">
                              {PageData.MissingReadonlyLabel}
                            </dd>
                          )}
                        </>
                      )}
                    </dl>
                  </>
                )}

              {Model.PageDataBase.IsPhoneMobileVisible &&
                Model.ContactDetailsConfiguration.mobilePhone !==
                  FieldType.Unavailable && (
                  <>
                    <dl>
                      <dt>{PageData.PhoneMobileLabel}</dt>
                      {!isNullOrWhiteSpace(Model.ContactDetails.PhoneMobile) ? (
                        <dd>{Model.ContactDetails.PhoneMobile}</dd>
                      ) : (
                        <>
                          {Model?.ContactDetailsConfiguration.mobilePhone ===
                          FieldType.Editable ? (
                            <dd className="Phonenumber-add">
                              {PageData.AddNowLabel}
                            </dd>
                          ) : (
                            <dd className="Phonenumber-add">
                              {PageData.MissingReadonlyLabel}
                            </dd>
                          )}
                        </>
                      )}
                    </dl>
                  </>
                )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Phone;
